import { info } from '@boc/organization/brands/jsn';

export const brandInfo = info;
